.container {
  gap: var(--mirai-ui-space-M);
  max-height: calc(100vh - calc(var(--mirai-ui-space-XL) * 4));
  min-height: calc(var(--mirai-ui-space-L) * 4.75);
  overflow: auto;
  padding: var(--mirai-ui-space-XS);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.form input.name {
  border-radius: var(--mirai-ui-border-radius);
  border-width: var(--mirai-ui-border-width);
  border: var(--mirai-ui-input-text-border);
  box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.03), 0px 3px 6px rgba(0, 0, 0, 0.02);
  line-height: 42.3984px;
  min-height: 42.3984px;
  padding: 0 var(--mirai-ui-space-S) 0 var(--mirai-ui-space-S);
}

.form input.name:focus {
  border-color: var(--mirai-ui-accent);
  box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.03), 0px 3px 6px rgba(0, 0, 0, 0.02), 0 0 0 3px hsla(204, 64%, 40%, 25%),
    0 1px 1px 0 rgba(0, 0, 0, 0.08);
  outline: 0px;
}

.form input.name.error {
  color: var(--mirai-ui-error);
  border-color: var(--mirai-ui-error);
  box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.03), 0px 3px 6px rgba(0, 0, 0, 0.02), 0 0 0 1px var(--mirai-ui-error);
  margin-bottom: calc(var(--mirai-ui-space-XXS) / 2);
}

.button {
  align-self: center;
  margin: var(--mirai-ui-space-XS) 0 var(--mirai-ui-space-S) 0;
}
